const topics = [
  { label: '明星恋情', heat: '128.6万', icon: 'ri-heart-line' },
  { label: '综艺争议', heat: '96.3万', icon: 'ri-tv-line' },
  { label: '网红翻车', heat: '87.1万', icon: 'ri-alert-line' },
  { label: '合约纠纷', heat: '72.5万', icon: 'ri-file-text-line' },
  { label: '直播事故', heat: '65.8万', icon: 'ri-live-line' },
  { label: '人设崩塌', heat: '54.2万', icon: 'ri-user-unfollow-line' },
  { label: '品牌代言', heat: '43.7万', icon: 'ri-store-line' },
  { label: '影视八卦', heat: '38.4万', icon: 'ri-film-line' },
  { label: '音乐圈瓜', heat: '29.1万', icon: 'ri-music-line' },
];

const faqs = [
  {
    q: '91吃瓜爆料网是什么平台？',
    a: '91吃瓜爆料网是国内领先的吃瓜视频聚合平台，专注收集整理娱乐圈明星八卦、社会热点事件、网红主播争议等热门爆料视频。我们提供91吃瓜视频在线观看与91吃瓜在线播放服务，所有视频即点即看，无需注册登录。',
  },
  {
    q: '91吃瓜视频在线观看需要付费吗？',
    a: '完全免费！91吃瓜爆料网所有吃瓜视频在线看资源均为免费开放，无需充值会员或付费订阅。我们通过聚合公开资源为瓜友提供便捷的一站式观看体验，让你轻松享受91吃瓜在线视频。',
  },
  {
    q: '网站视频更新频率如何？',
    a: '我们的编辑团队全天候追踪全网热点，每天入库50+最新吃瓜视频资源。重大事件发生后，通常在30分钟内即可上线相关视频内容。打开91吃瓜爆料网，随时都有新鲜瓜可吃。',
  },
  {
    q: '手机上可以观看91吃瓜在线视频吗？',
    a: '当然可以！91吃瓜爆料网全面适配手机端访问，无需下载任何APP。只需用手机浏览器打开网站，即可流畅体验91吃瓜视频在线观看与91吃瓜在线播放。支持iOS和Android系统，随时随地吃瓜。',
  },
  {
    q: '如何投稿或提供爆料素材？',
    a: '如果你有一手爆料线索或精彩吃瓜素材，欢迎通过网站"爆料投稿与联系"区域的邮箱或微信联系我们。请在投稿时尽量提供详细的文字说明和相关证据材料，我们的编辑将尽快核实并整理发布。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '91吃瓜爆料网采用多线路智能切换技术，如果当前视频播放出现卡顿，可以稍等缓冲或刷新页面重试。我们建议在WiFi环境下观看以获得最佳体验。如持续遇到问题，可通过联系方式反馈，我们会及时优化。',
  },
];

export default function TopicsFaqSection() {
  return (
    <>
      <section id="topics" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              当前最受关注的话题标签，点击探索更多精彩内容
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3">
            {topics.map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-3 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0 group-hover:bg-accent-500 transition-colors duration-200">
                  <i className={`${item.icon} text-lg text-accent-600 group-hover:text-background-50 transition-colors duration-200`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 truncate">
                    {item.label}
                  </div>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-fire-line text-xs text-primary-500"></i>
                    <span>{item.heat}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="faq" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              关于91吃瓜爆料网的常见疑问解答
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <div className="p-5">
                  <h3 className="flex items-start gap-3 text-sm md:text-base font-medium text-foreground-900">
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-primary-100 text-primary-600 rounded text-xs font-bold mt-0.5">
                      Q
                    </span>
                    <span>{item.q}</span>
                  </h3>
                  <div className="flex items-start gap-3 mt-3">
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-accent-100 text-accent-600 rounded text-xs font-bold mt-0.5">
                      A
                    </span>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}